import useWindowSize from "./useWindowSize";
export const useIsMobile = () => {
  const width = useWindowSize();
  const isMobile = width <= 900;
  return isMobile;
};
